module.exports = __webpack_public_path__ + "img/114.211d4587.jpg";